/* =========================

  BtnReset

============================ */
import styled from "styled-components";
import {break_point_sp} from "../../../Styled/mixin";
import {opacity_default} from "../../../Styled/mixin";

import { useSelector,useDispatch } from "react-redux";

/* -------------------------

  component

---------------------------- */
function BtnReset( props ) {
  const count = useSelector((state)=>state.count);
  const dispatch = useDispatch();

  let cancelFlag = 0;
  const doActionFunc = (e) => {
    if (cancelFlag === 0) {
      dispatch({type:"ADD_SUM",payload:0});

      dispatch({type:"ADD_COUNT",payload:1});

      let targets = document.querySelectorAll(`form[name="pekemaru"] input`);
      for(let i = 0 ; i < targets.length ; i++){
        targets[i].checked = false;
      }

      let targets_label = document.querySelectorAll(`form[name="pekemaru"] input+label`);
      for(let i = 0 ; i < targets_label.length ; i++){
        targets_label[i].classList.remove("isFadeIn");
      }

      cancelFlag = 1;
    }
    setTimeout(function () {
      cancelFlag = 0;
    }, 500);
  }

  return (
    <>
      <Styled className={`${(count > 1)?"isFadeInNormal":"isDisplayNone"}`}>
        <div className="c-btn_start">
          <div className="c-btn_start__inner">
            <div className="c-btn_start__btn" onClick={doActionFunc} >
              <p className="txt">はじめからやり直す</p>
            </div>
          </div>
        </div>
      </Styled>
    </>
  );
}

export default BtnReset;

/* -------------------------

  styled

---------------------------- */
const Styled = styled.div`
  .c-btn_start {
    color: #451700;
    .c-btn_start__btn {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: fit-content;
      margin: auto;
      padding: 16px 20px;
      background-color: #e3d8bb;
      border-radius: 50vw;
      cursor: pointer;
      /* ホバー時 */
      &:hover {
        ${opacity_default}
      }
      // 矢印アイコン
      &::before {
        content: "";
        display: block;
        width: 24px;
        height: 24px;
        background-image: url(${process.env.PUBLIC_URL}/assets/img/top/c-btn_reset-img01.png);
        background-size: 100% auto;
      }
      .txt {
        margin-left: 0.5em;
        font-size: 2rem;
        font-weight: 500;
        text-align: center;
        line-height: 1;
      }
    }
  }

  	@media ${break_point_sp} {
      .c-btn_start {
        .c-btn_start__btn {
          padding: 10px 20px;
          // 矢印アイコン
          &::before {
            width: calc(38 / 750 * 100vw);
            height: calc(38 / 750 * 100vw);
          }
          .txt {
            font-size: calc(30 / 750 * 100vw);
          }
        }
      }
	}
`;
